/*
 * @Author: zx
 * @Date: 2023-10-11 16:51:19
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-10-16 15:16:29
 * @Descripttion:
 */
import request from '@/utils/request'

// 热门图书列表
export function getList(params) {
  return request({
    url: '/api/site/contentList',
    method: 'get',
    params
  })
}

// 获取图书详细信息
export function getDetail(id) {
  return request({
    url: `/api/book/detail/${id}`,
    method: 'get'
  })
}

// 分类查询
export function getSubjectSearch(params) {
  return request({
    url: `/api/book/subjectSearch`,
    method: 'get',
    params
  })
}

// 博客列表查询
export function getBlogList(params) {
  return request({
    url: `/api/site/imageText/list`,
    method: 'get',
    params
  })
}
// 获取博客详情
export function getBlogDetail(id) {
  return request({
    url: `/api/site/imageText/${id}`,
    method: 'get'
  })
}
// 导航菜单列表
export function getNavMenu(id) {
  return request({
    url: `/api/navMenu/list`,
    method: 'get'
  })
}

// 获取菜单下的内容类型
export function contentList(menuId, contentType, page = '') {
  return request({
    url: `/api/navMenu/contentList?menuId=${menuId}&contentType=${contentType}${page}`,
    method: 'get'
  })
}

// 站点详细信息
export function getSite() {
  return request({
    url: `/api/site`,
    method: 'get'
  })
}

// 底部菜单已选信息
export function getBottomMenu() {
  return request({
    url: `/api/site/bottomMenu/list`,
    method: 'get'
  })
}
// 外部链接列表
export function getLinkList() {
  return request({
    url: `/api/site/link/list`,
    method: 'get'
  })
}

// 条件搜索
export function conditionSearch(params) {
  return request({
    url: `/api/book/conditionSearch`,
    method: 'get',
    params
  })
}
